import * as React from "react";
import { ButtonGroup, ButtonGroupChoice } from "@access-selfcare/shared-libs";
import { useAtom } from "jotai";
import { activeFilterStatusAtom, EVENT_STATUS } from "../Hooks/useEventsDashboard";
import { features } from "utils/logger/features";
import { featureTracking } from "components/common/event.tracking";

const buttons: ButtonGroupChoice<EVENT_STATUS>[] = [
  { id: EVENT_STATUS.ALL.toString(), element: "All", value: EVENT_STATUS.ALL },
  { id: EVENT_STATUS.PENDING.toString(), element: "Pending", value: EVENT_STATUS.PENDING },
  { id: EVENT_STATUS.ATTENDING.toString(), element: "Attending", value: EVENT_STATUS.ATTENDING },
  { id: EVENT_STATUS.DECLINED.toString(), element: "Declined", value: EVENT_STATUS.DECLINED },
  { id: EVENT_STATUS.ISSUED.toString(), element: "Issued", value: EVENT_STATUS.ISSUED },
];

const EventsStatusButtonGroup: React.FC = () => {
  const [activeFilter, toggleFilter] = useAtom(activeFilterStatusAtom);

  const handleOnChange = (value: EVENT_STATUS): void => {
    switch (value) {
      case EVENT_STATUS.ALL:
        featureTracking(features.welcomePageAllFilterActivate);
        break;
      case EVENT_STATUS.PENDING:
        featureTracking(features.welcomePagePendingFilterActivate);
        break;
      case EVENT_STATUS.ATTENDING:
        featureTracking(features.welcomePageAttendingFilterActivate);
        break;
      case EVENT_STATUS.DECLINED:
        featureTracking(features.welcomePageDeclinedFilterActivate);
        break;
      case EVENT_STATUS.ISSUED:
        featureTracking(features.welcomePageIssuedFilterActivate);
        break;
      default:
        break;
    }
    toggleFilter(value);
  };

  return (
    <div className="form-group mt-3">
      <label className="form-label">Type</label>
      <div style={{ whiteSpace: "nowrap" }}>
        <ButtonGroup
          selected={activeFilter}
          elements={buttons}
          onSelect={handleOnChange}
          className="btn-group-md mt-2"
        />
      </div>
    </div>
  );
};

export default EventsStatusButtonGroup;
